import styled from "styled-components/macro";

export const Button = styled.button`
  background-color: ${({ bg, theme }) =>
    theme.colors[bg] || theme.colors.indigo};
  color: white;
  border: none;
  font: inherit;
  cursor: pointer;
  outline: none;
  border-radius: ${({ borderRadius }) => borderRadius || 0};
  box-shadow: initial;
  width: ${({ width }) => width || "initial"};
  text-align: center;
  font-weight: ${({ weight }) => weight || 400};
  font-size: ${({ fontSize, theme }) =>
    theme.fontSize[fontSize] || theme.fontSize.base};
  line-height: ${({ lineHeight }) => lineHeight || "18px"};
  padding: ${({ padding }) => padding};
  transition: 0.4s;

  &:hover {
    background-color: ${({ hoverBg }) => hoverBg || "#37CFD6"};
  }
`;
